export default __webpack_public_path__ + "static/media/coronavirus.d85cbf18.png";